import React, { useEffect } from "react";
import {useStyles} from "../styles/EvenDialogueGenerateSentenceStyle";
import { Box, Tabs, Tab } from "@material-ui/core";
import clsx from "clsx";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";
import EvenDialogueSentence from "./EvenDialogueSentence";
import EvenDialogueRole from "./EvenDialogueRole";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function EvenStepOne(props) {
    const classes = useStyles();

    const {contentStore, evenStepOneStore} = props;
    const {contentTapIndex} = evenStepOneStore;

    useEffect(() => {
        evenStepOneStore.getEvenStepOneContent(contentStore.stepValue, contentStore.dayValue);
        contentStore.setOnSave(onSave);
        return ()=> {
            contentStore.setOnSave(null);
            evenStepOneStore.initEvenStepOneContent(contentStore.stepValue, contentStore.dayValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSave = () => {
        evenStepOneStore.modifyEvenStepOneContent(contentStore.stepValue, contentStore.dayValue);
    }

    const handleTabChange = (event, newValue) => {
        evenStepOneStore.setContentTapIndex(newValue);
    };

    return (
        <div className={classes.root}>
            <EvenDialogueRole/>
            <Box className={clsx(classes.boxWrap, classes.heightStep2)}>
                <Box>
                    <Box position="static" className={classes.tabBox}>
                        <Tabs value={contentTapIndex} onChange={handleTabChange} aria-label="simple tabs example">
                            <Tab label="한국어" {...a11yProps(0)} disableRipple/>
                            <Tab label="영어" {...a11yProps(1)} disableRipple/>
                            <Tab label="일본어" {...a11yProps(2)} disableRipple/>
                            <Tab label="중국어" {...a11yProps(3)} disableRipple/>
                        </Tabs>
                    </Box>
                    <Box className={classes.textBox}>
                        <EvenDialogueSentence tabIndex={contentTapIndex} selectedContent={evenStepOneStore.selectedContent}/>
                    </Box>
                </Box>
            </Box>
        </div>
    );
}
export default withRouter(inject('contentStore','evenStepOneStore')(observer(EvenStepOne)));
